import { render, staticRenderFns } from "./VendorNavigation.vue?vue&type=template&id=2fffc79b&scoped=true&"
import script from "./VendorNavigation.vue?vue&type=script&lang=js&"
export * from "./VendorNavigation.vue?vue&type=script&lang=js&"
import style0 from "./VendorNavigation.vue?vue&type=style&index=0&id=2fffc79b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fffc79b",
  null
  
)

export default component.exports